var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.visible)?_c('div',{staticClass:"loading"},[_c('Loading')],1):_vm._e(),_c('div',{class:{'disable-page': _vm.visible }})])
}
var staticRenderFns = []

export { render, staticRenderFns }